import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PublicOcRequestForm from '../../components/OrganoidRequest/PublicOcRequestForm';
import PublicOrganoidFormShell from '../../components/OrganoidRequest/PublicOrganoidFormShell';
import { createPublicOcRequest } from '../../clients/oc_request_client';
import { storeOcClientToken } from '../../utils/ocRequest';
import { showToast } from '../../config_and_helpers/helpers';
import { logInfo } from '../../config_and_helpers/logger';

const LOG_CONTEXT = 'PublicOcRequestCreatePage';

/**
 * Public create page at /request/new — mint glass shell + Materiah/Hadassah logos.
 */
const PublicOcRequestCreatePage = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async payload => {
    setSubmitting(true);
    const result = await createPublicOcRequest(payload);
    setSubmitting(false);
    if (!result.success) {
      showToast(result.messages?.[0] || 'Submit failed', 'error', 'top-center', 5000);
      return;
    }
    const token = result.data.client_access_token;
    storeOcClientToken(token);
    logInfo(LOG_CONTEXT, 'public request created', {
      requestNumber: result.data.request_number,
    });
    showToast('Request submitted', 'success', 'top-center', 3000);
    navigate(`/request/${token}/confirmation`, {
      state: {
        request_number: result.data.request_number,
        token_expires_at: result.data.token_expires_at,
        status: result.data.status,
      },
    });
  };

  return (
    <PublicOrganoidFormShell
      title="Organoid Culture Order Request"
      subtitle="Submit a new culture order request. You will receive a secure link to track and respond."
    >
      <PublicOcRequestForm onSubmit={handleSubmit} submitting={submitting} />
    </PublicOrganoidFormShell>
  );
};

export default PublicOcRequestCreatePage;
